/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidCellsControllerEditMutationRequest, BidCellsControllerEditMutationResponse, BidCellsControllerEdit400, BidCellsControllerEdit401, BidCellsControllerEdit403, BidCellsControllerEdit404 } from "../../models/bidsController/BidCellsControllerEdit";

function getBidCellsControllerEditUrl() {
  const res = { method: 'PUT', url: `/api/v1/bid-cells` as const }  
  return res
}

/**
 * @description Sets what a trade partner’s bid says for a scope row, creating the cell if the bid never covered it. The edit locks the cell and supersedes its pending suggestions. Saving the value it already has locks it as is.
 * @summary Edit a cell, locking it
 * {@link /api/v1/bid-cells}
 */
export async function bidCellsControllerEdit(data?: BidCellsControllerEditMutationRequest, config: Partial<RequestConfig<BidCellsControllerEditMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidCellsControllerEditMutationResponse, ResponseErrorConfig<BidCellsControllerEdit400 | BidCellsControllerEdit401 | BidCellsControllerEdit403 | BidCellsControllerEdit404>, BidCellsControllerEditMutationRequest>({ method : "PUT", url : getBidCellsControllerEditUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}